import actions from './actions';
import mutations from './mutations.js';
import getters from './getters.js';


const state = {
  currencies : {},
  price_list : {},
  tariffs : [],
};

export default {
    namespaced: false,
    state,
    actions,
    mutations,
    getters,
}